export { ActionPaths as ActionPathsTable } from './ActionPaths';
